/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: "new-user-form",
  formField: {
    nama: {
      name: "nama",
      label: "Nama",
      type: "text",
      errorMsg: "Nama Lengkap Beserta Gelar Harus Diisi.",
    },
    instansi: {
      name: "instansi",
      label: "Instansi",
      type: "text",
      errorMsg: "Instansi Harus Diisi.",
    },
    pangkat: {
      name: "pangkat",
      label: "Pangkat",
      type: "select",
      errorMsg: "Pangkat Harus Diisi.",
    },
    email: {
      name: "email",
      label: "Email Address",
      type: "email",
      errorMsg: "Email Username RSS Harus Diisi.",
      invalidMsg: "alamat email tidak valid",
    },
    jabatan: {
      name: "jabatan",
      label: "Jabatan",
      type: "select",
      errorMsg: "jabatan diperlukan.",
    },
    bidang: {
      name: "bidang",
      label: "Bidang",
      type: "select",
      errorMsg: "bidang diperlukan.",
    },
    status: {
      name: "status",
      label: "Status",
      type: "select",
      errorMsg: "status diperlukan.",
    },
    unit: {
      name: "unit",
      label: "Unit",
      type: "select",
    },

    facebook: {
      name: "facebook",
      label: "Facebook Account",
      type: "text",
    },
    instagram: {
      name: "instagram",
      label: "Instagram Account",
      type: "text",
    },

    bio: {
      name: "bio",
      label: "Bio",
      type: "text",
    },
  },
};

export default form;
